import type {
    ClickTriggerConfig,
    CreateRecordTriggerConfig,
    MatchConditionTriggerConfig,
    NodeTypes,
    ScheduledTriggerConfig,
    UpdateRecordTriggerConfig,
    WebhookTriggerConfig,
    WebsocketTriggerConfig
} from '@lighthouse/shared'
import React from 'react'

import * as SC from '../../styles'
import { TriggerModeDataSource } from '../components/TriggerModeDataSource'

interface EmptyTriggerConfigureProps {
    nodeType: NodeTypes
    onNodeTypeChange: (val: NodeTypes) => void
    onNodeNameChange: (name: string) => void
    value:
        | CreateRecordTriggerConfig
        | UpdateRecordTriggerConfig
        | MatchConditionTriggerConfig
        | ScheduledTriggerConfig
        | ClickTriggerConfig
        | WebsocketTriggerConfig
        | WebhookTriggerConfig
    onChange: (
        value:
            | CreateRecordTriggerConfig
            | UpdateRecordTriggerConfig
            | MatchConditionTriggerConfig
            | ScheduledTriggerConfig
            | ClickTriggerConfig
            | WebsocketTriggerConfig
            | WebhookTriggerConfig
    ) => void
}

export const EmptyTriggerConfigure: React.FC<EmptyTriggerConfigureProps> = ({
    nodeType,
    value,
    onChange,
    onNodeTypeChange,
    onNodeNameChange
}) => {
    return (
        <SC.Container>
            <TriggerModeDataSource
                nodeType={nodeType}
                value={value}
                onChange={onChange}
                onNodeTypeChange={onNodeTypeChange}
                onNodeNameChange={onNodeNameChange}
            />
        </SC.Container>
    )
}
